/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillActivation
*/
export var SkillActivation;
(function (SkillActivation) {
    SkillActivation["HIDDEN"] = "HIDDEN";
    SkillActivation["MANUAL"] = "MANUAL";
    SkillActivation["TRIGGER"] = "TRIGGER";
    SkillActivation["AGENT"] = "AGENT";
})(SkillActivation || (SkillActivation = {}));
//# sourceMappingURL=SkillActivation.js.map